// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bddU","label":"styles_label__28QL6"};